import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BoundaryFeeModel, DayOfWeekEnum } from 'app/models';
import { XpToggleOption, XpToggleValue } from '@xp/toggle-buttons/xp-toggle-buttons.component';

@Component({
    selector: 'edit-boundary-fee-dialog',
    templateUrl: './edit-boundary-fee-dialog.component.html',
    styleUrls: ['./edit-boundary-fee-dialog.component.scss',
        '../../../../../../styles/menu-sidebar.scss',
        '../../../../../../styles/style-layout.scss'
    ]
})
export class EditBoundaryFeeDialogComponent implements OnInit {
    public visibleEditBoundaryFeeDialog: boolean = false;
    @Input()
    set _visibleEditBoundaryFeeDialog(value: boolean) {
        this.visibleEditBoundaryFeeDialog = value;
    }

    @Input()
    public boundaryFeeModel: BoundaryFeeModel = new BoundaryFeeModel();

    @Output() boundaryFeeChange = new EventEmitter<BoundaryFeeModel>();
    @Output() changedVisibleEditBoundaryFeeDialog = new EventEmitter<boolean>();

    public dayOptions: XpToggleOption[] = [
        { label: 'Sun', value: DayOfWeekEnum.Sunday },
        { label: 'Mon', value: DayOfWeekEnum.Monday },
        { label: 'Tue', value: DayOfWeekEnum.Tuesday },
        { label: 'Wed', value: DayOfWeekEnum.Wednesday },
        { label: 'Thu', value: DayOfWeekEnum.Thursday },
        { label: 'Fri', value: DayOfWeekEnum.Friday },
        { label: 'Sat', value: DayOfWeekEnum.Saturday }
    ];

    public isLoading: boolean = false;
    public timeStartString: string = '';
    public timeEndString: string = '';

    ngOnInit(): void {
        this.timeStartString = this.toTimeString(
            this.boundaryFeeModel.BoundaryAvailableFromHours,
            this.boundaryFeeModel.BoundaryAvailableFromMins
        );
        this.timeEndString = this.toTimeString(
            this.boundaryFeeModel.BoundaryAvailableToHours,
            this.boundaryFeeModel.BoundaryAvailableToMins
        );
    }

    private toTimeString(hour: number, minute: number): string {
        return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    }

    public toggleDay(day: XpToggleValue): void {
        const days = [...(this.boundaryFeeModel.BoundaryAvailableDays ?? [])];
        const index = days.indexOf(day as DayOfWeekEnum);
        if (index >= 0) {
            days.splice(index, 1);
        } else {
            days.push(day as DayOfWeekEnum);
        }
        this.boundaryFeeModel.BoundaryAvailableDays = days;
    }

    saveBoundaryFee() {
        if (this.timeStartString) {
            const [h, m] = this.timeStartString.split(':').map(Number);
            this.boundaryFeeModel.BoundaryAvailableFromHours = h;
            this.boundaryFeeModel.BoundaryAvailableFromMins = m;
        }
        if (this.timeEndString) {
            const [h, m] = this.timeEndString.split(':').map(Number);
            this.boundaryFeeModel.BoundaryAvailableToHours = h;
            this.boundaryFeeModel.BoundaryAvailableToMins = m;
        }
        this.boundaryFeeChange.emit(this.boundaryFeeModel);
    }

    public cancel() {
        this.changedVisibleEditBoundaryFeeDialog.emit(false);
    }
}
